<template>
  <div>
    <Form ref="form" :model="queryForm" :label-width="80" inline style="margin-top: 20px">
      <Row type="flex" justify="space-between">
        <Col>
          <FormItem label="帮扶项目：" prop="projectId">
            <Select v-model="queryForm.projectId" style="width: 200px" clearable>
              <Option v-for="item in projectList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="报名人：" prop="name">
            <Input v-model="queryForm.name" placeholder="输入关键词搜索"></Input>
          </FormItem>
        </Col>
        <Col>
          <FormItem label="" style="text-align: right">
            <Button type="primary" style="margin-right: 10px" @click="getList(1)">搜索</Button>
            <Button @click="handleResetForm">重置</Button>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <Row type="flex" align="middle" style="margin-bottom: 20px" v-if="status === '1'">
      <Button @click="doneSelection" v-if="ids && ids.length">批量完成</Button>
      <Button disabled v-else>批量完成</Button>
      <Col style="color: #c5c8ce; margin: 0 0 0 10px">*请在报名人参加帮扶项目后点击“已完成”</Col>
    </Row>
    <Row type="flex" align="middle" style="margin-bottom: 20px" v-if="status === '2'">
      <Dropdown placement="bottom-start" v-if="ids && ids.length">
        <Button>批量完成</Button>
        <template v-slot:list>
          <DropdownMenu>
            <DropdownItem>
              <div class="select-add" sbz-click @click="confirm(null)">批量通过</div>
            </DropdownItem>
            <DropdownItem>
              <div class="select-add" sbz-click @click="refuse(null)">批量拒绝</div>
            </DropdownItem>
          </DropdownMenu>
        </template>
      </Dropdown>
    </Row>
  </div>
</template>
      </Dropdown>
      <Button disabled v-else>批量完成</Button>
    </Row>
    <Row type="flex" align="middle" style="margin-bottom: 20px" v-if="status === '4'">
      <Col style="color: #c5c8ce">*等待求职者确认，确认后可以获得对应积分</Col>
    </Row>

    <Table ref="selection" :columns="columns" :data="data1" :loading="loading" @on-selection-change="changeSelection">
      <template  v-slot:project="{ row }">
        <div>{{ row.project.name }}</div>
      </template>
      <template  v-slot:name="{ row }">
        <div>{{ row.user.name }}</div>
      </template>
      <template  v-slot:mobile="{ row }">
        <div>{{ row.user.mobile }}</div>
      </template>
      <template  v-slot:time="{ row }">
        <div>{{ row.createdAt | formatTime }}</div>
      </template>
      <template  v-slot:gender="{ row }">
        <div>{{ row.user.gender }}</div>
      </template>
      <template  v-slot:age="{ row }">
        <div>{{ row.user.age }}</div>
      </template>
      <template  v-slot:degree="{ row }">
        <div>{{ row.user.degree }}</div>
      </template>
      <template  v-slot:status="{ row }">
        <a v-if="row.user && row.user.user && row.user.user.resume" style="margin-right: 10px" @click="showResume(row.user.user.resume)">查看简历</a>
        <span v-if="row.status === 2">
          <a style="margin-right: 10px" @click="confirm(row)">同意</a>
          <a @click="refuse(row)">拒绝</a>
        </span>
        <a v-if="row.status === 1" @click="done([row.id])">已完成</a>
      </template>
    </Table>

    <div style="display: flex; align-items: center; margin-top: 20px">
      <Page
        v-if="pagination.count"
        style="padding: 10px; background: #fff"
        class="page"
        @on-change="changePage"
        :current="pagination.pageIndex"
        :total="pagination.count"
        :page-size="pagination.pageSize"
        size="small"
        show-elevator
      />
    </div>

    <Modal v-model="showResumeModal" :width="700" :footer-hide="true" title="查看简历">
      <resume :info="info" :noInterview="0"></resume>
    </Modal>
  </div>
</template>
<script>
import resume from '@/view/components/resume';
import { mapActions } from 'vuex';
export default {
  props: {
    status: {
      type: String,
      default: 1
    },
    planId: {
      type: String,
      default: 0
    }
  },
  watch: {
    status() {
      this.getList();
    },
    planId() {
      this.getProjects();
      this.getList();
    }
  },
  components: { resume },
  data() {
    return {
      showResumeModal: false,
      queryForm: {},
      projectList: [],
      loading: false,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '报名项目',
          slot: 'project',
          minWidth: 300
        },
        {
          title: '报名人',
          slot: 'name',
          width: 120
        },
        {
          title: '联系电话',
          slot: 'mobile',
          width: 120
        },
        {
          title: '报名时间',
          slot: 'time',
          width: 180
        },
        {
          title: '性别',
          slot: 'gender',
          width: 120
        },
        {
          title: '年龄',
          slot: 'age',
          width: 150
        },
        {
          title: '学历',
          slot: 'degree',
          width: 150
        },
        {
          title: '操作',
          slot: 'status',
          width: 160,
          fixed: 'right'
        }
      ],
      data1: [],
      pagination: {},
      info: {},
      ids: []
    };
  },
  methods: {
    ...mapActions(['getHelpCount']),
    changeSelection(e) {
      this.ids = [];
      e.forEach(item => {
        this.ids.push(item.id);
      });
    },
    doneSelection() {
      this.done(this.ids);
    },
    changePage(page) {
      this.getList(page);
    },
    getProjects() {
      this.$axios
        .request({
          url: 'front/v1/company/help-plan-project',
          method: 'get',
          params: { pageSize: 100, planId: this.planId }
        })
        .then(res => {
          this.projectList = res.data.list;
        });
    },
    getList(page = 1) {
      let query = Object.assign({ pageIndex: page }, this.queryForm, {
        planId: this.planId,
        status: this.status
      });
      this.loading = true;
      this.ids = [];
      this.$axios
        .request({
          url: 'front/v1/company/help-user-plan-project',
          method: 'get',
          params: query
        })
        .then(res => {
          this.loading = false;
          this.data1 = res.data.list;
          this.pagination = { count: res.data.count, pageIndex: res.data.pageIndex, pageSize: res.data.pageSize };
        });
    },
    handleResetForm() {
      this.$refs.form.resetFields();
      this.getList(1);
    },
    done(ids) {
      this.$Modal.confirm({
        title: '请确认是否完成了就业帮扶',
        content: '<p>完成后工会将会核实，要继续吗？</p>',
        okText: '继续',
        cancelText: '取消',
        onOk: () => {
          this.$axios
            .request({
              url: 'front/v1/company/help-user-plan-project/confirm',
              method: 'PUT',
              data: { ids: ids }
            })
            .then(res => {
              this.getList(this.pagination.pageIndex);
              this.getHelpCount();
            });
        }
      });
    },
    confirm(row) {
      this.$Modal.confirm({
        title: '提示',
        content: '是否同意取消报名申请？',
        okText: '同意',
        cancelText: '取消',
        onOk: () => {
          this.$axios
            .request({
              url: 'front/v1/company/help-user-plan-project/cancel',
              method: 'PUT',
              data: { ids: (row && [row.id]) || this.ids, status: 1 }
            })
            .then(res => {
              this.getList(this.pagination.pageIndex);
            });
        }
      });
    },
    refuse(row) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认拒绝申请吗？',
        okText: '拒绝',
        cancelText: '取消',
        onOk: () => {
          this.$axios
            .request({
              url: 'front/v1/company/help-user-plan-project/cancel',
              method: 'PUT',
              data: { ids: [row.id] || this.ids, status: 2 }
            })
            .then(res => {
              this.getList(this.pagination.pageIndex);
            });
        }
      });
    },
    showResume(item) {
      this.showResumeModal = true;
      this.info = item;
    }
  }
};
</script>
